import { InsertDocument } from './insert-document.js';
import { EditDocument } from './edit-document.js';


export function Document (pEditor)
{
  this.insert = new InsertDocument(pEditor, this);
  this.edit = new EditDocument(pEditor, this);
}